import { styled } from "@mui/system";
export const ConditionalModifyButtonContent = styled("span") `
    font-size: 10px;
`;
